import { useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

export default function useBootstrapSize() {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isLessTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isMiniDesktop = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isBigDesktop = useMediaQuery(theme.breakpoints.up('xl'));

  // Медиа-запросы для высоты
  const isShortHeight = useMediaQuery('(max-height: 600px)');
  const isMediumHeight = useMediaQuery('(max-height: 800px)');
  const isTallHeight = useMediaQuery('(min-height: 1000px)');

  const sizeComponent = isMobile ? 'small' : 'medium';

  return {
    isMobile,
    isTablet,
    isMiniDesktop,
    isDesktop,
    isLessTablet,
    sizeComponent,
    isShortHeight,
    isMediumHeight,
    isBigDesktop,
    isTallHeight
  };
}
